export enum CancelActionType {
  CANCEL_SHIFT = "CANCEL_SHIFT",
  KEEP_SHIFT = "KEEP_SHIFT",
}
